<script setup lang="ts">
import type { SiteBlockData, SiteBlockSettings } from '../../../types/site'

const props = defineProps<{ data: SiteBlockData, settings: SiteBlockSettings }>()

const isExternal = computed(() =>
  !!props.data.button_url && /^(https?:|mailto:|tel:)/.test(props.data.button_url))
</script>

<template>
  <div class="site-bg-accent-soft rounded-[var(--site-radius)] px-6 py-10 text-center sm:px-10">
    <h3 class="site-display text-2xl tracking-tight sm:text-3xl">
      {{ data.headline }}
    </h3>
    <p
      v-if="data.subtext"
      class="mx-auto mt-3 max-w-xl text-[var(--site-muted)]"
    >
      {{ data.subtext }}
    </p>
    <NuxtLink
      v-if="data.button_text && data.button_url"
      :to="data.button_url"
      :external="isExternal"
      class="site-btn-accent mt-6 inline-block px-6 py-3 font-semibold transition"
    >
      {{ data.button_text }}
    </NuxtLink>
  </div>
</template>
